/**
 * 报修工单状态映射表
 */
export const repairStatusMap = {
  '0': '',
  '1': '待派单',
  '2': '勘察中',
  '3': '审批中',
  '4': '维修中',
  '5': '待验收',
  '6': '待支付',
  '7': '已完成',
  '9': '已取消',
  '10': '待指派供应商',
  '11': '待填写报价(审价)',
  '12': '已转投诉单'
}

/**
 * 根据状态码获取状态文本
 * @param {string|number} status - 状态码
 * @returns {string} 状态文本
 */
export function getRepairStatusText(status) {
  return repairStatusMap[String(status)] || '-'
}

/**
 * 获取所有状态选项（用于下拉选择）
 * @returns {Array} 状态选项数组 [{value: '1', label: '待派单'}, ...]
 */
export function getRepairStatusOptions() {
  return Object.keys(repairStatusMap)
    .filter(key => key !== '0') // 排除空值
    .map(key => ({
      value: key,
      label: repairStatusMap[key]
    }))
}
